import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

import { AccountSettingsService } from 'app/main/pages/account-settings/account-settings.service';
import { retryWhen, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CustomerService } from 'services/customer.service';

import Swal from 'sweetalert2';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-location-sidebar',
  templateUrl: './location-sidebar.component.html'
})
export class LocationSidebarComponent implements OnInit {

  @Input() currentLocation;
  @Output() newItemEvent = new EventEmitter<string>();

  public data: any;
  public loadingButton = false;
  
  public alertClose = true;
  public alert = "Error!";

  public practitionersList: any;

  public isSmallDisplay = true;

  public onboardContent: any;
  // private
  private _unsubscribeAll: Subject<any>;

  public imageChangedEvent: any = '';
  public croppedImage: any = '';
  public selectedImage: any = '';


  /**
   * Constructor
   *
   * @param {CoreSidebarService} _coreSidebarService
   */
  constructor(
    private _coreSidebarService: CoreSidebarService, 
    private _httpClient: HttpClient,
    private _customersService: CustomerService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private _accountSettingsService: AccountSettingsService) {
    this._unsubscribeAll = new Subject();
  }

  /**
   * Toggle the sidebar
   *
   * @param name
   */
  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    this.addNewItem(this.currentLocation);
    this.alertClose = true;
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.selectedImage = '';
    this.currentLocation =  {
      "id": null,
      "userId": [],
      "locationName": "",
      "locationAddress": "",
      "locationZipCode": "",
      "locationPhone": "",
      "locationLogo": "",
      "locationEmail": "",
      "locationWebsite": "",
      "locationDocId": "",
      "locationDocType": "ABN",
      "locationTimeZone": "",
      "locationCurrency": "AUD",
      "locationStatus": "",
      "settings": {
        "member_referral": {
            "isActive": false,
            "creditAmount": 0,
            "membership_amount": 0,
            "membership_percentage": 0,
            "setup_amount": 0,
            "setup_percentage": 0
        },
        "dependent_discount": {
            "isActive": false,
            "goal": 0,
            "membership_amount": 0,
            "membership_percentage": 0,
            "setup_amount": 0,
            "setup_percentage": 0
        }
    }
    };
  }



    /**
   * Upload Image
   *
   * @param event
   */
     uploadImage(event1: any) {
      if (event1.target.files && event1.target.files[0]) {
        let reader = new FileReader();
        reader.onload = (event2: any) => {
          let width;
          let height;
          let img = new Image();
          img.src = event2.target.result;
          img.onload = (event3: any) => {
            let targetImg = event3.currentTarget as HTMLImageElement;
            width = targetImg.width;
            height = targetImg.height;  
            
            if (width == height && height == 150 ) {
              this.currentLocation['locationLogo'] = event2.target.result;
              
  
            }else{
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'The image size must be 150 x 150',
                showConfirmButton: true,
                allowOutsideClick: function () {
                  return !Swal.isLoading();
                }
              });
            }
            
            
          }
        };
        reader.readAsDataURL(event1.target.files[0]);
      }
    } 
    
    /**
   * Delete Image
   *
   */
    deleteImage() {
      this.currentLocation['locationLogo'] = "";      
    } 

    fileChangeEvent(event: any): void {
      this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || "") ;
      this.selectedImage = event.blob
      
      // event.blob can be used to upload the cropped image
    }
    imageLoaded(image: LoadedImage) {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }

    selectCroppedImage(){
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedImage); 
      reader.onloadend = (event2: any) => {
        var base64data = reader.result;                
        this.currentLocation['locationLogo'] = base64data;
      }
      
         
    }
  
      /**
    * Send New Contact
    */
    openSender(modalLG): void {
      this.modalService.open(modalLG, {
        centered: true,
        size: 'lg'
      });
      
      requestAnimationFrame(() => {
        const changePicture = document.getElementById('change-picture');
        if (changePicture) {
          changePicture.click();
        }
      });
      
    }

        /**
   * Open link
   *
   */
    activateLocation(locationId) {
      var link = window.location.href.split('?')
      var return_link = {'return_link': link[0] + '?active=4'};
  
      this._customersService
      .activateLocation(locationId, return_link)
      .then(
        data => {             
          if(data['url'] == null){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: data['description'],
              showConfirmButton: true,
              allowOutsideClick: function () {
                return !Swal.isLoading();
              }
            });
    
  
          }else{
            window.open(data['url'], '_self'); 
          }
        },
        error => {
        }
      );
  
    }
          
          
        

  /**
   * Submit
   *
   * @param form
   */
  submit(form, type) {
    if (form.valid) {
      this.loadingButton = true;
      switch (type) {
        case 'new':
          return new Promise((resolve, reject) => {
            this._httpClient
              .post(`${environment.apiUrl}/location`, this.currentLocation)
              .subscribe((response) => {
                this.addNewItem(response);
                resolve(response);
                this.toggleSidebar("location-sidebar");
                this.loadingButton = false;
                Swal.fire({
                  icon: "question",
                  title: "Activate Now?",
                  html: "<div><p>Click on the button below to activate this location.</p></div>",
                  confirmButtonText: "Activate",
                  cancelButtonText: "Skip",

                  showClass: { popup: "animate__animated animate__flipInX" },
                  showCancelButton: true,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((data) => {
                  if (data.isConfirmed == true) {
                    var link = window.location.href.split("?");
                    var return_link = { return_link: link[0] + "?active=4" };
    
                    this._customersService.activateLocation(response['id'], return_link).then(
                      (data) => {
                        if (data["url"] == null) {
                          Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: data["description"],
                            showConfirmButton: true,
                            allowOutsideClick: function () {
                              return !Swal.isLoading();
                            },
                          });
                        } else {
                          window.open(data["url"], "_self");
                        }
                      },
                      (error) => {
                        // this.loading = false;
                      }
                    );
                  } else {
                    var reason = String(data.dismiss);
                    switch (reason) {
                      case "cancel":
                        break;
    
                      default:
                        break;
                    }
                  }
                });
              }, reject);
          }).catch((error) => {
            this.loadingButton = false;
            this.toggleSidebar('location-sidebar');
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error,
              showConfirmButton: true,
              allowOutsideClick: function () {
                return !Swal.isLoading();
              },
            });
          });

        case 'update':
        
          return new Promise((resolve, reject) => {
            this._httpClient.patch(`${environment.apiUrl}/location/${this.currentLocation.id}`, this.currentLocation).subscribe(response => {
              this.addNewItem(response);
              this.loadingButton = false;

              if(response['locationStatus'] == 'pending' && response['merchantAccount'] != ''){
                Swal.fire({
                  icon: "question",
                  title: "Activate Now?",
                  html: "<div><p>Click on the button below to activate this location.</p></div>",
                  confirmButtonText: "Activate",
                  cancelButtonText: "Skip",

                  showClass: { popup: "animate__animated animate__flipInX" },
                  showCancelButton: true,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((data) => {
                  if (data.isConfirmed == true) {
                    var link = window.location.href.split("?");
                    var return_link = { return_link: link[0] + "?active=4" };
    
                    this._customersService.activateLocation(response['id'], return_link).then(
                      (data) => {
                        if (data["url"] == null) {
                          Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: data["description"],
                            showConfirmButton: true,
                            allowOutsideClick: function () {
                              return !Swal.isLoading();
                            },
                          });
                        } else {
                          window.open(data["url"], "_self");
                        }
                      },
                      (error) => {
                        // this.loading = false;
                      }
                    );
                  } else {
                    var reason = String(data.dismiss);
                    switch (reason) {
                      case "cancel":
                        break;
    
                      default:
                        break;
                    }
                  }
                });
              };
    
              resolve(response);
              this.toggleSidebar('location-sidebar');
    
            }, reject);
          })
          .catch((error) => {
            this.loadingButton = false;
            this.toggleSidebar('location-sidebar');
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error,
              showConfirmButton: true,
              allowOutsideClick: function () {
                return !Swal.isLoading();
                
              }
            });
          });
    
        default:
          break;
      }



    }
  }

  addNewItem(value: any) {
    this.newItemEvent.emit(value);
  }


  ngOnInit(): void {
    this.isSmallDisplay = window.screen.width < 1000;    
    this._accountSettingsService.onSettingsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      this.data = response;
    });   
  };


}
